<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [title]="'Sign Up'"
    [class]="extraClass"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />


    <tidy-card>
      <form [formGroup]="form">
        @if (giftCodeMessage && this.giftCode?.giver_name) {
          <tidy-row [align]="'center'">
            <tidy-text
              [header]="giftCodeMessage" />
          </tidy-row>
        }
        @if (flowType === 'private') {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-row>
              <tidy-text
                [header]="'Instantly Book'" /><span>&nbsp;</span>
                <tidy-text
                  [header]="proName | titlecase" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="proName | titlecase" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'from'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="proTeamName | titlecase" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'uses TIDY to let you book & reschedule appointments online. It\’s free for you to use.'" />
                    </tidy-row>
                  </tidy-row>
                }

                <tidy-row>
                  <tidy-select
                    formControlName="language"
                    [form]="form.controls.language"
                    [label]="'Language'"
                    [icon]="'assets/svg/globe-outline.svg'"
                    [items]="languageItems"
                    [multiple]="false"
                    (optionChange)="selectLanguage($event)" />
                </tidy-row>

                <tidy-row>
                  <tidy-input
                    formControlName="firstName"
                    [form]="form.controls.firstName"
                    [label]="'First Name'"
                    [errorMessage]="'Please enter your first name.'"
                    [submitted]="submitted"
                    [icon]="'assets/svg/person-outline.svg'" />
                </tidy-row>

                <tidy-row>
                  <tidy-input
                    formControlName="lastName"
                    [form]="form.controls.lastName"
                    [label]="'Last Name'"
                    [errorMessage]="'Please enter your last name.'"
                    [submitted]="submitted"
                    [icon]="'assets/svg/person-outline.svg'" />
                </tidy-row>

                <tidy-row>
                  <tidy-input
                    formControlName="email"
                    [form]="form.controls.email"
                    [label]="'Email'"
                    type="email"
                    [errorMessage]="'Please enter a valid email.'"
                    [submitted]="submitted"
                    [icon]="'assets/svg/mail-outline.svg'" />
                </tidy-row>

                <tidy-row>
                  <tidy-input
                    formControlName="password"
                    [form]="form.controls.password"
                    [label]="'Password'"
                    [errorMessage]="'Password enter a password.'"
                    [submitted]="submitted"
                    type="password"
                    [icon]="'assets/svg/lock-closed-outline.svg'" />
                </tidy-row>

                @if (flowType === 'normal' || flowType === 'private') {
                  @if (accountTypes?.length > 0) {
                    <tidy-row class="extra-top-padding">
                      <tidy-text
                        [body]="'What are you using us for?'" />
                    </tidy-row>
                  }
                  <tidy-row>
                    <tidy-radio-button
                      formControlName="type"
                      [form]="form.controls.type"
                      [items]="accountTypes"
                      [errorMessage]="'Please select an option'"
                      [submitted]="submitted"
                      (optionChange)="selectType($event)" />
                  </tidy-row>
                }

                @if (form?.value?.type === 'rental' || flowType === 'rental') {
                  <tidy-row class="extra-top-padding">
                    <tidy-text
                      [body]="'Describe your business:'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-radio-button
                      formControlName="ownerType"
                      [form]="form.controls.ownerType"
                      [items]="ownerTypeItems"
                      [errorMessage]="'Please select an answer.'"
                      [submitted]="submitted"
                      (optionChange)="selectOwnerType($event)" />
                  </tidy-row>
                  @if (form.controls.ownerType.value !== 'live_in_rental') {
                    <tidy-row>
                      <tidy-input
                        formControlName="numberOfProperties"
                        [label]="'How many rental properties do you manage?'"
                        [form]="form.controls.numberOfProperties"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter the number of properties.'"
                        [icon]="'assets/svg/home.svg'"
                        inputMode="numeric"
                        [mask]="'number'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-input
                        formControlName="accountName"
                        [label]="'What is the name of your company? (optional)'"
                        [form]="form.controls.accountName"
                        [icon]="'assets/svg/briefcase.svg'" />
                    </tidy-row>
                  }
                }

                <tidy-row class="extra-top-padding">
                  <tidy-grid>
                    <ion-row>
                      <ion-col size="auto">
                        <tidy-checkbox
                          style="position: relative; top: -10px;"
                          formControlName="terms"
                          [form]="form.controls.terms"
                          [items]="[{viewValue: '', value: true}]" />
                      </ion-col>
                      <ion-col>
                        <tidy-text
                          [body]="'I agree to the terms, which includes agreeing to individual arbitration.*'" />
                        <tidy-text
                          (action)="openTerms()"
                          [body]="'Read terms'"
                          class="link" />
                      </ion-col>
                    </ion-row>
                  </tidy-grid>
                </tidy-row>

                @if (termsError) {
                  <tidy-row>
                    <tidy-error-message
                      [text]="'You must agree to the terms to continue.'" />
                  </tidy-row>
                }
              </form>
            </tidy-card>

            <tidy-error-message
              [text]="errorMessage" />

            <tidy-row>
              <tidy-button
                [text]="'Continue'"
                class="primary"
                [action]="boundCreateAccount" />
            </tidy-row>

            @if (flowType === 'normal' || flowType === 'rental' || flowType === 'company') {
              <tidy-row [align]="'center'" class="extra-bottom-padding">
                <tidy-text
                  [body]="'Already have an account? '" />
                <tidy-text
                  (action)="goToLoginPage()"
                  [body]="'Log In'"
                  class="link" />
              </tidy-row>
            }

            @if (flowType === 'maintenance') {
              <tidy-row [align]="'center'">
                <tidy-text
                  [header]="'Use TIDY to:'" />
              </tidy-row>
              <tidy-alert>
                <ion-row>
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/tool-box.svg'"
                      style="width:40px;height:50px" />
                  </tidy-row>
                  <ion-col>
                    <tidy-row>
                      <tidy-text
                        [header]="'Get Maintenance Tips'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="'We will tell you what the manufacturer recommends for each item.'" />
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-alert>
              <tidy-alert>
                <ion-row>
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/house-sketch.svg'"
                      style="width:40px;height:50px" />
                  </tidy-row>
                  <ion-col>
                    <tidy-row>
                      <tidy-text
                        [header]="'Create a Sharable Map'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="'Your map will be with your checklist to help your pro visually get the job done right.'" />
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-alert>
              <tidy-alert>
                <ion-row>
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/light-bulb.svg'"
                      style="width:40px;height:50px" />
                  </tidy-row>
                  <ion-col>
                    <tidy-row>
                      <tidy-text
                        [header]="'Clean Smarter'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="'Knowing what is in your home helps you and any pros you use follow best practices for that exact thing.'" />
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-alert>
            }

            @if (!windowService.isDesktopRes && flowType !== 'private' && flowType !== 'developer') {
              <tidy-alert>
                <tidy-row [align]="'center'" class="extra-bottom-padding">
                  <tidy-text
                    [header]="'Over 10,000 Happy Clients'" />
                </tidy-row>
                @for (quote of quotes; track quote; let first = $first) {
                  <tidy-row [ngClass]="first ? 'extra-bottom-padding' : ''">
                    <tidy-grid>
                      <ion-row>
                        <ion-col size="3">
                          <tidy-image
                            style="margin: auto; width: 40px"
                            [src]="quote?.icon" />
                        </ion-col>
                        <ion-col>
                          <tidy-text
                            [body]="quote?.text" />
                        </ion-col>
                      </ion-row>
                      <tidy-row [align]="'right'">
                        <tidy-text
                          [body]="'- ' + quote?.person" />
                      </tidy-row>
                    </tidy-grid>
                  </tidy-row>
                }
              </tidy-alert>
            }

            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'*If you would like an alternate agreement, contact sales@tidy.com instead of agreeing to these terms.'" />
            </tidy-row>
          </tidy-wrapper>
        </ng-template>

        <ng-template #rightColumn>
          <!--Note this used to be a wrapper, but it was making the 10px at the bottom less opaque so I removed-->
          <!--Couldn't figure out why-->
          @if (loaded && windowService.isDesktopRes && flowType !== 'private' && flowType !== 'developer') {
            <div style="margin: 10px">
              <tidy-row [align]="'center'" class="extra-bottom-padding">
                <tidy-text
                  [header]="'Over 10,000 Happy Clients'" />
              </tidy-row>
              @for (quote of quotes; track quote; let first = $first) {
                <tidy-row [ngClass]="first ? 'extra-bottom-padding' : ''">
                  <tidy-grid>
                    <ion-row>
                      <ion-col size="3">
                        <tidy-image
                          style="margin: auto; width: 40px"
                          [src]="quote?.icon" />
                      </ion-col>
                      <ion-col>
                        <tidy-text
                          [body]="quote?.text" />
                      </ion-col>
                    </ion-row>
                    <tidy-row [align]="'right'">
                      <tidy-text
                        [body]="'- ' + quote?.person" />
                    </tidy-row>
                  </tidy-grid>
                </tidy-row>
              }
            </div>
          }
        </ng-template>

        <app-scroll-wrapper [templateRightColumn]="rightColumn" [templateContent]="content" />
